﻿$.fn.dxCtrlPageSupportExterne = function custom_dxCtrlPageSupportExterne(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlpagesupportexterne dx-ctrl");
        this.createInstance(new cdxCtrlPageSupportExterne(this, option));
    }
    return this;
}

window.cdxCtrlPageSupportExterne = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        var popup = container.dxCtrlPopupBase({
            fullScreen: true,
            showTitle: false,
            showMaximize: false,
            contentTemplate: function (contentElement) {
                popupContentElement = contentElement
                //popupContentElement.css("background-color", "black")
                popupContentElement.css("padding-top", "10px")
                popupContentElement.css("position", "relative")
            },
            onShown: function (e) {
                if (option.allowClose) {
                    $("<div style='position:absolute;z-index:101;top:2px;right:2px'/>").appendTo(popupContentElement).dxCtrlButton({
                        icon: 'fas fa-times',
                        width: HeightButton,
                        height: HeightButton,
                        onClick: function (e) {
                            popup.hide();
                        }
                    }).dxCtrlButton("instance");
                }

                var $DivTop = $("<div style='border-bottom:" + theme.border + ";'/>").appendTo(popupContentElement)
                var $Table = $("<table/>").appendTo($DivTop)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px;cursor:pointer;padding-right:5px;'/>").appendTo($Tr)
                var $Img = $("<img src='" + parametre.img + "' style='width:50px'/>").appendTo($Td)
                $Td.on("click", function () { window.open(parametre.url_site_vitrine, "_blank"); })
                //var $Td = $("<td style='width:100%;font-size:40px;font-style:italic;opacity:0.2;'>SUPPORT " + parametre.nom + "</td>").appendTo($Tr)
                var $Td = $("<td style='width:100%;font-size:40px;font-style:italic;opacity:0.2;'></td>").appendTo($Tr)
                var opt = {
                    bddCtrl: option.bddCtrl,
                    isGestionnaire: ((typeof option.isGestionnaire != 'undefined') ? option.isGestionnaire : false)
                }
                opt.idSupportTicket = option.idSupportTicket
                opt.idCompteClient = option.idCompteClient
                opt.idUtilisateurClient = option.idUtilisateurClient
                opt.idUtilisateurGest = option.idUtilisateurGest
                opt.isExterne = true
                $("<div style='width:100%;height:calc(100% - " + $Table.innerHeight() + "px);'/>").appendTo(popupContentElement).dxCtrlContentTotalSupport(opt)
            }
        }).dxCtrlPopupBase("instance")
        popup.show()
    }

    this.element = function () { return container }

    mConstruit();
}